import type React from 'react'

export const getInputType = (
  type: React.HTMLInputTypeAttribute,
  isPasswordVisible: boolean
) => {
  if (type !== 'password') return type
  return isPasswordVisible ? 'text' : 'password'
}
